export default function () {
	$('form[id="newsletter-signup-form"]').submit(function(e) {
	    e.preventDefault();

	    var form = $('form[id="newsletter-signup-form"]');
	    var email = $("[name='nl_email']", form).val();

	    if (email + '' == '') {
	        alert('Please enter a valid email address');
	    } else {
	        var postUrl = 'http://e.group.com/public/?';
	        var emailInit = 'email=' + email + '&';
	        var q = 'q=direct_add&';
	        var fn = 'fn=Public_DirectAddForm&';
	        var id = 'id=calfswkovkxuttebeilmbuzwshzhbnp&';
	        var createCookie = 'createCookie=1&';
	        var sendWelcome = 'sendWelcome=no&';
	        var messageId = 'messageId=105acbd33db49dbf68f93ab14a01d66c&';
	        var fromName = 'fromName=Group Publishing&';
	        var fromAddress = 'fromAddress=info@group.com&';
	        var masterList = 'list3=0bd403ec0000000000000000000000058a38&';
	        var src = postUrl + emailInit + q + fn + id + createCookie + sendWelcome + messageId + fromName + fromAddress + masterList;

	        $('#newsletter-signup-form').append('<img src="' + src + '" style="display:none;" width="0" height="0" border="0" />');

	        $.ajax({
                url: 'https://services.group.com/svcBrontoSHA256?email=' + email,
            })
            .done(function(data) {
                var json = $.parseJSON(data);
                var jsonStatus = json.status;
                if (jsonStatus == 'success') {
                    var prefCenterUrl = json.leadInfo.prefCenterUrl
                    window.open(prefCenterUrl, '_blank').focus();
                } else {
                    alert('Unable to process your request. Please contact customer support.');
                }
            })
            .fail(function() {
                alert('Unable to process your request. Please contact customer support.')
            })
	    }

	});
}
